import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 3.4A2.6 2.6 0 0 0 3.4 6v12A2.6 2.6 0 0 0 6 20.6h12a2.6 2.6 0 0 0 2.6-2.6V6A2.6 2.6 0 0 0 18 3.4H6ZM1.4 6A4.6 4.6 0 0 1 6 1.4h12A4.6 4.6 0 0 1 22.6 6v12a4.6 4.6 0 0 1-4.6 4.6H6A4.6 4.6 0 0 1 1.4 18V6Zm14.945 2.934a1 1 0 0 1-.079 1.412l-5.37 4.8a1 1 0 0 1-1.332 0l-1.83-1.636a1 1 0 1 1 1.332-1.491l1.164 1.04 4.703-4.204a1 1 0 0 1 1.412.079Z"
  />,
  'CheckSquareContained'
)
